import cn from 'classnames';
import React, { FC, ReactNode, memo } from 'react';
import { useNavigate } from 'react-router';

import Typography from '@mui/material/Typography';

import useStyles from './styles.module';

interface Props {
  label: string;
  path?: string;
  icon: ReactNode;
  onClose: () => void;
  withPadding?: boolean;
  isComingSoon?: boolean;
  newTab?: boolean;
  isBlueIcon?: boolean;
}

const Item: FC<Props> = ({
  label,
  path,
  icon,
  onClose,
  withPadding = false,
  isComingSoon = false,
  newTab = false,
  isBlueIcon = false,
}: Props) => {
  const navigate = useNavigate();
  const { classes } = useStyles();

  const handleRedirect = () => {
    if (!path) return;

    if (newTab) {
      window.open(path, '_self _blank');
    } else {
      navigate(path);
    }

    onClose();
  };

  return (
    <button
      onClick={handleRedirect}
      className={cn(classes.item, {
        [classes.withPadding]: withPadding,
      })}
    >
      <div
        className={cn(classes.item, {
          [classes.comingSoon]: isComingSoon,
        })}
      >
        <div className={cn(classes.icon, { [classes.blueIcon]: isBlueIcon })}>
          {icon}
        </div>
        <Typography variant="body1" color={(theme) => theme.primary.p2}>
          {label}
        </Typography>
      </div>
      {isComingSoon && (
        <Typography
          variant="caption1"
          className={classes.label}
          color={(color) => color.primary.p2}
        >
          Coming soon
        </Typography>
      )}
    </button>
  );
};

export default memo(Item);
